import * as Sentry from '@sentry/browser';
import { initLoc as initLocalization, t } from '../../../packages/src/localization/index.js';

export { t };

export function saveLocParams({ orgId, eventCode }) {
  sessionStorage.setItem('locParams', JSON.stringify({ orgId, eventCode }));
}

function getLocParams() {
  return JSON.parse(sessionStorage.getItem('locParams') || '{}');
}

export async function initLoc({ orgId, eventCode } = getLocParams()) {
  if (!orgId || !eventCode) {
    const error = new Error('Organisation ID and Event Code are required for localisation initialization.');
    Sentry.captureException(error);
  }
  await initLocalization({ orgId, eventCode, projectName: 'webapp' });
}

export function setTextToElement(cssPath, text) {
  const element = document.querySelector(cssPath);
  if (element) {
    element.textContent = text;
  } else {
    const error = new Error(`Element not found for CSS path: ${cssPath}`);
    console.error(error);
    Sentry.captureException(error);
  }
}
